import { SectionContainer } from "../molecules/section-container";
import React from "react";

export const OnboardingPage: React.FC = () => {
  return <SectionContainer>{"Onboarding"}</SectionContainer>;
};
